import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { listDomains, domainState } from '../../domains/domainSlice';
import { listRoles } from '../../roles/roleSlice';
import { generateKey, apiKeyState, resetCreatedKey, listApiKeys } from '../apiKeySlice';
import { GenerateKeyInput } from '../models/GenerateKey.interface';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useRolesByTeam } from '../../roles/hooks/useRoles';
import { useForm } from "react-hook-form";
import SmashSelect from '../../../components/SelectInput/SmashSelect';
import { uuidv4 } from "smash-idhelper";
import { validateLabelLength } from '../../../shared/validation/length';

interface GenerateKeyForm {
    handleClose: () => void,
    // onDomainChange: (value:string) => void,
}

const GenerateKeyForm = (props: GenerateKeyForm) => {
    const { handleClose } = props;
    const dispatch = useAppDispatch();
    type FormValues = {
        // username: string;
        label: string;
        // tokenDuration: string;
        teamId: string;
        roleId: string;
    };

    const { handleSubmit, setError, formState: { errors }, register, control } = useForm<FormValues>({
        mode: "onTouched",
        reValidateMode: "onChange"
    });

    // const [selectedDomainOption, setSelectedDomainOption] = useState<string>();
    // const selectDomainChange = ({label, value}: any) => {
    //     dispatch(listRoles()); // need to make sure we have a fresh list of roles
    //     setSelectedDomainOption(value);
    //     onDomainChange(value)
    // };

    // const [_, rolesByTeam] = useRolesByTeam(selectedDomainOption as string);

    const submitHandler = (values: FormValues) => {
        const generateKeyInput: GenerateKeyInput = {
            username: uuidv4(),
            label: values.label,
            tokenDuration: "100y",
        };
        dispatch(generateKey(generateKeyInput));
    }

    // const { list: domainsList } = useAppSelector(domainState);
    const { createdKey } = useAppSelector(apiKeyState);

    useEffect(() => {
        if (createdKey.isError) {
            setError("label", { type: "custom", message: createdKey.error?.message });
            dispatch(resetCreatedKey());
        }

        if (createdKey.isSuccess) {
            dispatch(resetCreatedKey());
            dispatch(listApiKeys());            
        }

        // if (!domainsList.isSuccess && !domainsList.isLoading) {
        //     dispatch(listDomains());
        // }
    }, [createdKey, dispatch]);

    // const domainOptions = domainsList.domains.map((domain) => ({ value:domain.id, label: domain.name}));

    if (createdKey.isLoading) {
        return < SmashSpinner />;
    }

    return (
        <>
            <Form id="generateKey-form" noValidate onSubmit={handleSubmit(submitHandler)}>
                <Form.Group className="mb-3" controlId="apiKeyName">
                    <Form.Label>API key name <small>(Required)</small></Form.Label>
                    <Form.Control
                        {...register('label', { required: true, validate: {length: validateLabelLength} })}
                        type="text"
                        placeholder="Enter an API key name"
                        isInvalid={!!errors.label}
                    />
                    {errors.label?.type === "length" && (
                        <Form.Control.Feedback type="invalid">
                            API key name must contain at least 2 char
                        </Form.Control.Feedback>)}
                    {errors.label?.type === "custom" && (
                        <Form.Control.Feedback type="invalid">
                            {errors.label.message}
                        </Form.Control.Feedback>)}
                    {errors.label?.type === "required" && (
                        <Form.Control.Feedback type="invalid">
                            API key name is required
                        </Form.Control.Feedback>)}
                </Form.Group>
                {/* <Form.Group className="mb-3" controlId="tokenDuration">
                    <Form.Label>ApiKey Duration</Form.Label>
                    <Form.Control
                        {...register('tokenDuration', { required: true })}
                        type="number"
                        placeholder="ApiKey Duration"
                        isInvalid={!!errors.tokenDuration}
                    />
                    {errors.tokenDuration?.type === "required" && (
                        <Form.Control.Feedback type="invalid">
                            Please provide a duration for the API key.
                        </Form.Control.Feedback>)}
                </Form.Group> */}
                <br />
                {/* <Form.Group className="mb-3" controlId="teamId">
                    <Form.Label>Domains</Form.Label> */}

                    {/* <Form.Select
                        {...register('teamId', { required: true, onChange: selectDomainChange })}
                        isInvalid={!!errors.teamId}>
                        <option className="d-none" value="">Choose...</option>
                        {domainsList.domains.map((domain, idx) => (
                            <option key={idx} value={domain.id}>{domain.name}</option>
                        ))}
                    </Form.Select> */}
                    
                    
                    {/* <SmashSelect 
                                rules={{ required: true}}
                                control={control}
                                name={'teamId'}
                                placeholder="Choose..."
                                options={domainOptions}
                                onChangeHook={selectDomainChange}
                                isInvalid={!!errors.teamId}                                
                            /> */}
{/* 

                    {errors.teamId?.type === "required" && (
                        <Form.Control.Feedback type="invalid">
                            Please provide a domain for the key.
                        </Form.Control.Feedback>)} */}
                {/* </Form.Group> */}

                {/* FOR NOW THERE IS ONLY ONE ROLE : APIKEY */}
                {/* {selectedDomainOption && rolesByTeam[0] && <Form.Control
                    {...register('roleId')}
                    type="text"
                    hidden
                    value={rolesByTeam[0].name}
                    isInvalid={!!errors.roleId}
                />} */}

                {/* <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <Button variant="light" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button disabled={!rolesByTeam[0]} variant="primary" type="submit">
                        Create
                    </Button>
                </div> */}
            </Form>
        </>
    )
}

export default GenerateKeyForm

